import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({children}) => {
    const token = localStorage.getItem('token');
    const area_type = localStorage.getItem('area_type');

    if (token !== null && area_type === 'REGISTRO') {
        return children
    } else {
        return <Navigate to="/login" replace={true} />
    }

}

export default PrivateRoute;